const TableFilterMixins = {
    data() {
        return {
            tableSplitFields: [],
            tableKey: 0,
            tableSplitFieldsShow: [],
            tsTableFieldsObj: {}
        }
    },
    computed: {
        systemName() {
            return this.$store.getters.name
        },
        systemVersion() {
            return this.$store.getters.version
        }
    },
    mounted() {
        let tsTableFieldsObj = JSON.parse(localStorage.getItem('tsTableFieldsObj')) || {};
        if (tsTableFieldsObj && tsTableFieldsObj[this.systemName] && tsTableFieldsObj[this.systemName][this.$options.name]) {
            if (this.$refs.TableFilterPopover.tabsActiveName !== '') {
                this.tableSplitFields.push(...tsTableFieldsObj[this.systemName][this.$options.name][this.$refs.TableFilterPopover.tabsActiveName]);
            } else {
                this.tableSplitFields.push(...tsTableFieldsObj[this.systemName][this.$options.name]['0']);
            }
        } else {
            this.tableSplitFields = JSON.parse(JSON.stringify(this.tableItems.map(item => ({
                ...item,
                fieldIsShow: item.fieldIsShow !== undefined ? item.fieldIsShow : true,
                fieldIsDisabled: item.fieldIsDisabled !== undefined ? item.fieldIsDisabled : false
            }))));
        }
    },
    watch: {
        tableSplitFields: {
            deep: true,
            handler() {
                this.tableSplitFieldsShow = this.tableSplitFields.filter(item => item.fieldIsShow)
            }
        }
    }
}
export default TableFilterMixins